import {
  getMapperModelId,
  getMapperModels,
  postBasicMapping,
  postMapperFiles,
  getMapperTemplatesApi,
  getMapperTemplate,
  postMapperTemplate,
  patchMapperTemplate,
  deleteMapperTemplate,
  postMapperValidation,
  deleteMapperFileApi,
  getMapperFilesApi,
} from "../../helpers/jwt_helper";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import { call, put, delay, takeEvery, select } from "redux-saga/effects";
import {
  setMapperData,
  setMapperModelID,
  setMapperModels,
  successMapping,
  setErrorMapping,
  setMapperTemplate,
  setMapperTemplates,
  uploadTemplateError,
  setMapperValidation,
  showValidationProcess,
  hideValidationProcess,
  setMapperValidationSuccess,
  getMapperTemplates,
  setLoadBasicMapper,
  setMapperFileLoader,
  setMapperFiles
} from "./actions";

import {
  GET_MAPPER_MODEL_ID,
  POST_MAPPER_BASIC_MAPPER,
  POST_MAPPER_FILES,
  GET_MAPPER_MODELS,
  GET_MAPPER_TEMPLATES,
  POST_MAPPER_TEMPLATE,
  DELETE_MAPPER_TEMPLATE,
  PATCH_MAPPER_TEMPLATE,
  GET_MAPPER_TEMPLATE,
  POST_MAPPER_VALIDATION,
  GET_MAPPER_FILES,
  DELETE_MAPPER_FILES,
} from "./actionTypes";

function* onAddFiles({ payload: { data } }) {
  try {
    const formData = new FormData();
    formData.append("data", data);
    let response = yield call(postMapperFiles, formData);
    yield put(setMapperData(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetModels() {
  try {
    let response = yield call(getMapperModels);
    yield put(setMapperModels(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetModelId({ payload: { id } }) {
  try {
    let response = yield call(getMapperModelId, id);
    yield put(setMapperValidationSuccess(false));
    yield put(setMapperValidation([]));
    yield put(setMapperModelID(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddBasicMapper({ payload: data }) {
  try {
    yield put(setMapperValidationSuccess(false));
    yield put(setLoadBasicMapper(true));
    yield put(showValidationProcess());
    let params = {
      map_data: data.map_data,
      file_id: data.file_id,
      ...(data?.platform && { platform: data.platform })
    };
    yield call(postBasicMapping, data.model_id, params);
    yield delay(1500);
    yield put(hideValidationProcess());
    yield put(successMapping(true));
    yield put(setMapperValidation([]));
    yield put(setMapperValidationSuccess(false));
    yield put(setLoadBasicMapper(false));
  } catch (error) {
    yield delay(1500);
    yield put(hideValidationProcess());
    yield put(setLoadBasicMapper(false));
    yield put(setErrorMapping(true));
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetMapperTemplates({ payload: content_type }) {
  try {
    let response = yield call(getMapperTemplatesApi, content_type);
    yield put(setMapperTemplates(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetMapperTemplate({ payload: id }) {
  try {
    let response = yield call(getMapperTemplate, id);
    yield put(setMapperTemplate(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddMapperTemplate({ payload: data }) {
  try {
    yield call(postMapperTemplate, data);
    showSuccessMessage(`Template ${data.name} saved successfully`);
  } catch (error) {
    uploadTemplateError(true);
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteMapperTemplate({ payload: { id, content_type } }) {
  try {
    yield call(deleteMapperTemplate, id);
    yield put(getMapperTemplates(content_type));
    showSuccessMessage(`Template delete successfully`);
  } catch (error) {
    showErrorMessage(getErrorMessage("Something went wrong"));
  }
}

function* onPatchMapperTemplate({ payload: id, data }) {
  try {
    yield call(patchMapperTemplate, id, data);
    showSuccessMessage(`Template patch successfully`);
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPostMapperValidation({ payload: { id, data, model, platform } }) {
  try {
    yield put(setMapperValidationSuccess(false));
    yield put(setMapperValidation([]));
    yield put(showValidationProcess());
    let params = {
      file_id: id,
      map_data: data,
      ...(platform && { platform }),
    };
    yield call(postMapperValidation, model.id, params);
    yield delay(1500);
    yield put(hideValidationProcess());
    yield put(setMapperValidationSuccess(true));
  } catch (error) {
    let err = [];
    for (let [key, value] in error.response.data) {
      err.push(error.response.data[key]);
    }
    yield delay(1500);
    yield put(hideValidationProcess());
    yield put(setMapperValidation(err));
  }
}

function* onGetMapperFiles({ payload: data }) {
  try {
    yield put(setMapperFileLoader());

    let response = yield call(getMapperFilesApi, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setMapperFiles(response));
    yield put(setMapperFileLoader());
  } catch (error) {
    yield put(setMapperFileLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteMapperFile({ payload: id }) {
  try {
    let mapperFilesData = [
      ...(yield select(state => state.Mapper.mapperFilesData)),
    ];
    yield put(setMapperFileLoader());
    yield call(deleteMapperFileApi, id);
    yield call(onGetMapperFiles, { payload: mapperFilesData });
    yield put(setMapperFileLoader());
    showSuccessMessage("File has been deleted");
  } catch (error) {
    yield put(setMapperFileLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* mapperSaga() {
  yield takeEvery(GET_MAPPER_MODELS, onGetModels);
  yield takeEvery(GET_MAPPER_MODEL_ID, onGetModelId);
  yield takeEvery(POST_MAPPER_BASIC_MAPPER, onAddBasicMapper);
  yield takeEvery(POST_MAPPER_FILES, onAddFiles);
  yield takeEvery(GET_MAPPER_TEMPLATES, onGetMapperTemplates);
  yield takeEvery(GET_MAPPER_TEMPLATE, onGetMapperTemplate);
  yield takeEvery(POST_MAPPER_TEMPLATE, onAddMapperTemplate);
  yield takeEvery(DELETE_MAPPER_TEMPLATE, onDeleteMapperTemplate);
  yield takeEvery(PATCH_MAPPER_TEMPLATE, onPatchMapperTemplate);
  yield takeEvery(POST_MAPPER_VALIDATION, onPostMapperValidation);
  yield takeEvery(GET_MAPPER_FILES, onGetMapperFiles);
  yield takeEvery(DELETE_MAPPER_FILES, onDeleteMapperFile);
}

export default mapperSaga;
